import React, { Component } from "react";
import {form, ff, Loader, HorizontalLoader} from "@mc/mc-legacy";
import { Button } from "reactstrap";
import { FormErrors, reduxForm } from "redux-form";
import SpravaUctuApi from "../api/gen/core/SpravaUctuApi";
import CardTitle from "../components/layout/CardTitle";
import CaptchaApi from "../api/gen/core/CaptchaApi";
import CaptchaWidget from "../components/captcha/CaptchaWidget";
import { withLang } from "../i18n/withLang";
import { i18n } from "../i18n/i18n";
import { EospPageContent } from "../components/layout/EospPageContent";
import "./ResetPasswordPage.scss";
import {brandTitle} from "../i18n/Message";
import Banner from "../components/banner/Banner";
import {MessageHtmlText} from "../i18n/MessageHtmlText";

type FormData = {
  login: string;
  captcha: string;
};

class ResetPassword extends Component<any> {
  static validate = (data, props) => {
    const errors: FormErrors<FormData> = {};

      if (!data.login) {
      errors.login = i18n(props.lang, "ResetPasswordForm_login_required");
    }

    if (props.captchaConfig?.type && !data.captcha) {
      errors.captcha = i18n(props.lang, "ResetPasswordForm_captcha_required");
    }

    return errors;
  };

  render() {
    const { captchaConfig, handleSubmit, error, submitting } = this.props;

    return (
      <form.Form horiznotal onSubmit={handleSubmit}>
        <form.FormBody>
          {error && <form.ValidationErrors error={error} />}
          <ff.String
            className={"py-15"}
            disabled={submitting}
            placeholder={i18n(this.props.lang, "ResetPasswordForm_login")}
            label={false}
            name="login"
            required
          />
          <p><MessageHtmlText text={i18n(this.props.lang, "ResetPasswordForm_info")}/></p>
          {captchaConfig?.type && (
            <ff.Base componentClass={CaptchaWidget} name={"captcha"} label={false} className={"mt-2 text-right"} captchaConfig={captchaConfig} lang={this.props.lang} required />
          )}
        </form.FormBody>
        <form.FormActions submitting={submitting} submitButton={false}>
          <Button className={"btn btn-primary py-15"} disabled={submitting}>
              {i18n(this.props.lang, "ResetPasswordForm_button_obnovitHeslo")}
              {submitting && <HorizontalLoader />}
          </Button>
        </form.FormActions>
      </form.Form>
    );
  }
}

const ResetPasswordForm = withLang(
  reduxForm<FormData, any>({
    form: "newPassword",
    validate: ResetPassword.validate,
  })(ResetPassword)
);
/**
 * Stránka pro umožnění resetu zapomenutého hesla.
 */

class ResetPasswordPage extends React.Component<any> {
  state = {
    done: false,
    captchaConfig: null,
    captchaFetched: false
  };

  componentDidMount() {
    CaptchaApi.getCaptchaConfig().then(captchaConfig => this.setState({captchaConfig, captchaFetched: true}));
  }

  render() {
    const { done, captchaConfig, captchaFetched } = this.state;

    const title = brandTitle(this.props.lang);
    return (
      <>
          {typeof window !== "undefined" && window.appConfig?.isTST && (
              <Banner text="Testovací prostředí (TST)" />
          )}
          <EospPageContent className={"reset-password-page"}>
            <CardTitle title={title} >
              <h4 className={"font-weight-bold mb-4 sub-title"}>
                  {i18n(this.props.lang, "ResetPasswordPage_obnoveniHesla")}
              </h4>
            </CardTitle>
            {!captchaFetched && <Loader />}
            {!done && captchaFetched && (
              <ResetPasswordForm
                captchaConfig={captchaConfig}
                onSubmit={({ login, captcha }) => SpravaUctuApi.resetovatHeslo({ login: login, captcha: captcha })}
                onSubmitSuccess={() => this.setState({ done: true })}
              />
            )}
            {done && captchaFetched && (
              <div>
                  <p><MessageHtmlText text={i18n(this.props.lang, "ResetPasswordPage_done")}/></p>
              </div>
            )}
          </EospPageContent>
      </>
    );
  }
}

export default withLang(ResetPasswordPage);
